import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { LegalPageComponent } from './legal.page';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [LegalPageComponent],
  imports: [CommonModule, IonicModule, SharedModule],
  exports: [LegalPageComponent],
})
export class LegalModule {}
